import { Image, ImageProps } from 'expo-image';
import { StyleSheet } from 'react-native';

import { DatetimeShow } from '@fhs/ui';

import { montrealSmokedMeatCAEndDate, montrealSmokedMeatCAStartDate } from '../constants';
import { LtoContentCA } from '../lto-content/lto-content-ca';

export type TopMarketingImageProps = Omit<ImageProps, 'children' | 'source'>;

export function TopMarketingImage(props: TopMarketingImageProps) {
  return (
    <DatetimeShow
      before={montrealSmokedMeatCAEndDate}
      after={montrealSmokedMeatCAStartDate}
      default={
        <LtoContentCA
          thanksgivingSub={
            <>
              <Image
                source={require('./thanksgiving-turkey-sub-card-logo.webp')}
                placeholder={{ thumbhash: 'EcqGIYwnh5h/d3aHf3f4iFdmfol/Zzg' }}
                contentFit="contain"
                {...props}
                style={styles.thanksgivingLogo}
              />
              <Image
                source={require('./thanksgiving-turkey-sub-2025.webp')}
                placeholder={{ thumbhash: 'onqGBQAljaBItoh5WQHLAaQsBnmAe5aahw' }}
                alt="Thanksgiving Turkey Sub."
                contentFit="cover"
                {...props}
                style={[styles.thanksgivingSubImage]}
              />
            </>
          }
          default={
            <Image
              source={require('./hook-and-ladder.webp')}
              placeholder={{ thumbhash: 'IWqGDQIml4eBioL514eAdgxkF0dyiJH5Nw' }}
              alt="Hook & Ladder"
              contentFit="cover"
              {...props}
              style={[styles.marketingImage, props.style]}
            />
          }
        />
      }
    >
      <Image
        source={require('./montreal-smoked-meat.webp')}
        placeholder={{ thumbhash: 'XFmGDYImd4hwjIX5iJeQlQtICVdyiHapSA' }}
        alt="Montreal Smoked Meat. Stacked to the max"
        contentFit="cover"
        {...props}
        style={[props.style, styles.montreal]}
      />
    </DatetimeShow>
  );
}

const styles = StyleSheet.create({
  montreal: {
    aspectRatio: 1000 / 968,
    width: '96%',
    height: '96%',
    maxWidth: '70%',
    minHeight: 200,
    alignSelf: 'center',
  },
  marketingImage: {
    aspectRatio: 958 / 966,
    width: '96%',
    height: '96%',
    minHeight: 200,
    alignSelf: 'center',
  },
  thanksgivingSubImage: {
    aspectRatio: 800 / 811,
    alignSelf: 'center',
    width: '96%',
  },
  thanksgivingLogo: {
    alignSelf: 'center',
    width: '90%',
    height: 167,
    position: 'absolute',
    zIndex: 1,
    top: -30,
  },
});
